<div fxLayout="row" fxLayoutAlign="center">
	<div
		fxLayout="column"
		class="dark-grey-texts"
		ngClass="p-t-xxl m-t-xl"
		fxFlex.gt-xs="100%"
		fxFlex.xs="90%"
	>
		<div fxLayout="row" fxLayoutAlign="center" ngClass="p-b-xl">
			<h2
				class="text-align-center"
				i18n="@@homepage_org_products_whydonateProducts"
			>
				WhyDonate Products
			</h2>
		</div>
		<div
			fxLayout.gt-xs="row"
			fxLayout.xs="column"
			fxFlex="100%"
			fxLayoutAlign="center"
			fxLayoutGap="3%"
		>
			<div fxLayout="column" fxFlex.gt-sm="35%" fxFlex.sm="40%">
				<img
					src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/homeOrganisationProduct/public"
				/>
			</div>
			<div
				fxLayout="column"
				fxFlex.sm="45%"
				fxFlex.md="40%"
				fxFlex.lg="28%"
				fxLayoutAlign="center"
			>
				<div fxLayout="row">
					<mat-card-title
						class="inc-largetext-height"
						i18n="@@fundraising_site_fundraisingForBothHomeOrganization"
						>Fundraising Site for Individuals and Charities</mat-card-title
					>
				</div>
				<div fxLayout="row">
					<p
						class="inc-span-height"
						i18n="@@homepage_org_products_individualCharityContent"
					>
						On Whydonate you can start a personal fundraising campaign, a
						fundraiser for charity or a peer-to-peer fundraiser.
					</p>
				</div>
				<div fxLayout="row" fxLayoutAlign="flex-start center" ngClass="p-t-m">
					<a mat-button color="accent" (click)="languageForWhydonatePlatform()">
						<span
							class="mat-headline-6"
							i18n="@@fundraising_site_checkAllFeaturesHomeOrganization"
							>All Fundraising Features</span
						></a
					>
				</div>
			</div>
		</div>
	</div>
</div>
